import React, {useState} from 'react';
import {Controller, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as Yup from 'yup';
// import {convertGregorianDateToObjectDate} from 'src/helpers/utils';
// import Select from './Select';
import dayjs from "dayjs";
import DotLoading from '../../../DotLoading';
import DatePicker from "../../../Form/DatePicker";


interface Iprops {
  provinceOption: Array<any>;
  query: any;
  setQuery: (data: any) => void;
  userType?: boolean;
}

const FilterPilgrimList: React.FC<Iprops> = ({
                                               // provinceOption,
                                               query,
                                               setQuery,
                                               // userType,
                                             }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [submitted, setSubmitted] = useState<boolean>(false);

  const validationSchema = Yup.object().shape({});

  const {
    handleSubmit,
    control,
    // register,
    reset,
    // watch,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formState: {errors},
  } = useForm<any>({
    mode: 'onChange',
    // @ts-ignore
    resolver: yupResolver(validationSchema),
  });

  const convertDay = (day: any) => {
    const date = new Date(day);
    return dayjs(date).locale('en').format('YYYY-MM-DDT00:00:00');
  };

  const onSubmit = (values: any) => {
    setQuery(() => {
      return {
        ...query,
        departureDateFrom: values.goFrom ? convertDay(values.goFrom) : null,
        departureDateTo: values.goTo ? convertDay(values.goTo) : null,
        returnDateFrom: values.backFrom ? convertDay(values.backFrom) : null,
        returnDateTo: values.backTo ? convertDay(values.backTo) : null,
        // locked: values.locked,
        currentPage: 1
      };
    });
  };

  const handelRemoveFilter = () => {
    reset({
      name: null,
      nationalId: null,
      mobileNumber: null,
      departureOriginProvince: null,
      departureDestinationBorder: null,
    });
    setQuery(() => {
      return {
        ...query,
        departureDateFrom: null,
        departureDateTo: null,
        returnDateFrom:  null,
        returnDateTo:  null,
        currentPage: 1,
      };
    });
  };

  // const [goFrom, goTo , backFrom , backTo] = watch(['goFrom', 'goTo','backFrom','backTo']);

  return (
    <>
      <form className="w-full space-y-4 ml-4" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex gap-4 space-x-3 rtl:space-x-reverse">
          <div>
            <h6 className="text-right text-sm">تاریخ اعزام</h6>

            <div className="flex gap-2">
              <div className="w-full">
                <Controller
                  control={control}
                  name="goFrom"
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  render={({field: {onChange, onBlur, value, ref, name}}) => (
                    <DatePicker
                      // max={convertGregorianDateToObjectDate(goFrom)}
                      onChange={onChange}
                      onBlur={onBlur}
                      placeholder="از تاریخ"
                      selected={value}
                      error={errors.goFrom}
                      iClass={`ltr placeholder-rtl relative block w-full rounded-full bg-white px-5 pl-9 py-2 placeholder-gray-400 shadow-lg focus:outline-none disabled:bg-gray-50 sm:text-sm ${
                        errors ? 'border-1 border-rose-600' : ''
                      } focus-visible disabled:shadow-none`}
                      name={name}
                      // eslint-disable-next-line no-unneeded-ternary
                      aria-invalid={errors.goFrom ? true : false}
                    />
                  )}
                />

                <p className={`${errors.from ? 'visible' : 'invisible'} mt-1 text-xs text-red-600`}>
                  {errors.goFrom?.message}
                </p>
              </div>
              <div className="w-full">
                <Controller
                  control={control}
                  name="goTo"
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  render={({field: {onChange, onBlur, value, ref, name}}) => (
                    <DatePicker
                      // min={convertGregorianDateToObjectDate(goTo)}
                      onChange={onChange}
                      onBlur={onBlur}
                      placeholder="تا تاریخ"
                      selected={value}
                      error={errors.goTo}
                      iClass={`ltr placeholder-rtl relative block w-full rounded-full bg-white px-5 pl-9 py-2 placeholder-gray-400 shadow-lg        focus:outline-none disabled:bg-gray-50 sm:text-sm ${
                        errors ? 'border-1 border-rose-600' : ''
                      } focus-visible disabled:shadow-none`}
                      name={name}
                      // eslint-disable-next-line no-unneeded-ternary
                      aria-invalid={errors.goTo ? true : false}
                    />
                  )}
                />

                <p className={`${errors.goTo ? 'visible' : 'invisible'} mt-1 text-xs text-red-600`}>
                  {errors.goTo?.message}
                </p>
              </div>
            </div>

          </div>

          <div>
            <h6 className="text-right text-sm">تاریخ بازگشت</h6>

            <div className="flex gap-2">
              <div className="w-full">
                <Controller
                  control={control}
                  name="backFrom"
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  render={({field: {onChange, onBlur, value, ref, name}}) => (
                    <DatePicker
                      // max={convertGregorianDateToObjectDate(backFrom)}
                      onChange={onChange}
                      onBlur={onBlur}
                      placeholder="از تاریخ"
                      selected={value}
                      error={errors.backFrom}
                      iClass={`ltr placeholder-rtl relative block w-full rounded-full bg-white px-5 pl-9 py-2 placeholder-gray-400 shadow-lg focus:outline-none disabled:bg-gray-50 sm:text-sm ${
                        errors ? 'border-1 border-rose-600' : ''
                      } focus-visible disabled:shadow-none`}
                      name={name}
                      // eslint-disable-next-line no-unneeded-ternary
                      aria-invalid={errors.backFrom ? true : false}
                    />
                  )}
                />

                <p className={`${errors.backFrom ? 'visible' : 'invisible'} mt-1 text-xs text-red-600`}>
                  {errors.backFrom?.message}
                </p>
              </div>
              <div className="w-full">
                <Controller
                  control={control}
                  name="backTo"
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  render={({field: {onChange, onBlur, value, ref, name}}) => (
                    <DatePicker
                      // min={convertGregorianDateToObjectDate(backTo)}
                      onChange={onChange}
                      onBlur={onBlur}
                      placeholder="تا تاریخ"
                      selected={value}
                      error={errors.backTo}
                      iClass={`ltr placeholder-rtl relative block w-full rounded-full bg-white px-5 pl-9 py-2 placeholder-gray-400 shadow-lg        focus:outline-none disabled:bg-gray-50 sm:text-sm ${
                        errors ? 'border-1 border-rose-600' : ''
                      } focus-visible disabled:shadow-none`}
                      name={name}
                      // eslint-disable-next-line no-unneeded-ternary
                      aria-invalid={errors.backTo ? true : false}
                    />
                  )}
                />

                <p className={`${errors.backTo ? 'visible' : 'invisible'} mt-1 text-xs text-red-600`}>
                  {errors.backTo?.message}
                </p>
              </div>
            </div>

          </div>


          {/*
          {userType && (
            <div className="w-full">
              <input
                type="text"
                {...register('name')}
                placeholder="نام و نام خانوادگی زائر"
                className="rtl  relative block w-full rounded-full  bg-white px-5 py-2 placeholder-gray-400 shadow-lg focus:outline-none disabled:bg-gray-50 sm:text-sm  focus-visible disabled:shadow-none"
              />
            </div>
          )}
          <div className="w-full">
            <input
              onKeyPress={onPress}
              // onKeyPress={event => changeDigitToEnglish(event, setValue)}
              // onKeyPress={event => changeDigitToEnglish(event, setValue)}
              type="text"
              {...register('nationalId')}
              placeholder="کد ملی"
              className="rtl  relative block w-full rounded-full  bg-white px-5 py-2 placeholder-gray-400 shadow-lg focus:outline-none disabled:bg-gray-50 sm:text-sm  focus-visible disabled:shadow-none"
            />
          </div>
          <div className="w-full">
            <input
              onKeyPress={onPress}
              // onKeyPress={event => changeDigitToEnglish(event, setValue)}
              // onKeyPress={event => changeDigitToEnglish(event, setValue)}
              type="text"
              {...register('mobileNumber')}
              placeholder="موبایل"
              className="rtl  relative block w-full rounded-full  bg-white px-5 py-2 placeholder-gray-400 shadow-lg focus:outline-none disabled:bg-gray-50 sm:text-sm  focus-visible disabled:shadow-none"
            />
          </div>
          <div className="w-full">
            <input
              onKeyPress={onPress}
              // onKeyPress={event => changeDigitToEnglish(event, setValue)}
              // onKeyPress={event => changeDigitToEnglish(event, setValue)}
              type="text"
              {...register('departureDestinationBorder')}
              placeholder="مرز خروج"
              className="rtl  relative block w-full rounded-full  bg-white px-5 py-2 placeholder-gray-400 shadow-lg focus:outline-none disabled:bg-gray-50 sm:text-sm  focus-visible disabled:shadow-none"
            />
          </div>
          <div className="w-full ">
            <Controller
              control={control}
              name="departureOriginProvince"
              render={({field: {onChange, onBlur, value, name}}) => (
                <Select
                  onChange={onChange}
                  onBlur={onBlur}
                  selected={value}
                  // options={healthStatusOptions}
                  options={provinceOption}
                  placeholder="استان اعزام"
                  icons={{
                    selected: <div className="h-4 w-4 rounded-full border border-gray-400"/>,
                    default: (
                      <div className="flex h-4 w-4 items-center justify-center rounded-full border border-green-700">
                        <div className="h-2 w-2 rounded-full bg-green-700"/>
                      </div>
                    ),
                  }}
                  name={name}
                />
              )}
            />
          </div>
*/}
          <div className="flex items-center space-x-2 rtl:space-x-reverse">
            <button
              type="button"
              onClick={handelRemoveFilter}
              className="flex w-full items-center justify-center whitespace-nowrap rounded-full border bg-white px-4 py-1.5 text-sm rtl:space-x-reverse"
              style={{borderColor: '#175A76', color: '#175A76'}}
            >
              <span>حذف فیلتر</span>
            </button>
            <button
              type="submit"
              disabled={submitted}
              className="flex w-full items-center justify-center whitespace-nowrap rounded-full px-4 py-2 text-sm text-white rtl:space-x-reverse"
              style={{backgroundColor: '#175A76'}}
            >
              <span>{!submitted ? 'اعمال فیلتر' : <DotLoading/>}</span>
            </button>
          </div>
        </div>
      </form>
    </>
  );
};
export default FilterPilgrimList;
